import React, { useEffect } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";
import P1 from "../../images/p1.png";
import P2 from "../../images/p2.png";
import P3 from "../../images/p3.png";
import P4 from "../../images/p4.png";
import P5 from "../../images/p5.png";
import P6 from "../../images/p6.png";
import P7 from "../../images/p7.png";
import P8 from "../../images/p8.png";
import { GiBinoculars } from "react-icons/gi";

const project= [
  {
    id: 1,
    link: "https://rndmatch.web.app/",
    img: P1
  },
  {
    id: 2,
    link: "https://soloonfinalprelaunch.netlify.app/",
    img: P2
  },
  {
    id: 3,
    link: "https://favarrwebsite.netlify.app/",
    img: P3
  },
  {
    id: 4,
    link: "https://hannun.netlify.app/",
    img: P4
  },
  {
    id: 5,
    link: "https://easychoicewirelessapp.netlify.app/",
    img: P5
  },
  {
    id: 6,
    link: "https://egtos-1f892.web.app/",
    img: P6
  },
  {
    id: 7,
    link: "https://indexcoredemo.web.app/",
    img: P7
  },
  {
    id: 8,
    link: "https://ticketsfinalook.netlify.app/",
    img: P8
  },
]

function Portfolio() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="Portfolio border-bottom py-5" id="portfolio">
      <div className="container-lg">
        <div className="Portfolio__headings my-4 fs-5">
          <span
            className="Portfolio__headings--small text-uppercase"
            data-aos-duration={500}
            data-aos={"fade-out"}
            data-aos-offset={10}
          >
            _Portfolio
          </span>
          <h1
            className="Portfolio__headings--h1 mt-3"
            data-aos={"fade-out"}
            data-aos-duration={500}
            data-aos-offset={10}
          >
            My Portfolio
          </h1>
          <h4
            className="Portfolio__headings__detail my-3"
            data-aos={"fade-out"}
            data-aos-duration={500}
            data-aos-offset={10}
          >
            I am proud to showcase some of my recent projects that demonstrate
            my skills and expertise in web development. From developing personal websites to
            contributing to open source projects, these projects highlight my
            diverse skills and my commitment to delivering high-quality work.
          </h4>
        </div>
        <div className="row">
          {project.map((item)=>(
            <div
            className="col-md-4 col-sm-6 py-4"
            data-aos={"fade-right"}
            data-aos-duration={1200}
            data-aos-offset={50}
            key={item.id}
          >
            <a href={item.link} rel="noreferrer" target="_blank">
            <div className="Portfolio__image-container">
              <img
                alt="rndmatch"
                src={item.img}
                className="Portfolio__image-container__img"
              />
              <div className="Portfolio__image-container__overlay d-flex justify-content-center align-items-center">
                <GiBinoculars className="text-white Portfolio__image-container__overlay__icon" />
              </div>
            </div>
            </a>
          </div>
          ))}
          
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
